import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar,
   IonButton,
   IonList,
   IonItem,
   IonLabel,
   IonIcon,
   IonTextarea,
   IonInput,
   IonRadioGroup,
   IonRadio,
   IonDatetime,
   IonToggle,
   IonText,
   IonLoading,
   IonRow,
   IonCol,
   IonGrid,
   IonItemOptions,
   IonItemOption,
   IonItemSliding,
   IonSegment,
   IonSegmentButton,
   IonFab,
   IonFabButton,
   IonFabList,
   IonActionSheet,
   IonModal,
   IonBadge,
   IonItemDivider,
   useIonAlert,
   IonBackdrop
} from '@ionic/react';
import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { chevronDown, chevronForward, cloudUpload, documentText, saveOutline, closeCircle, checkmarkCircle, refreshOutline, playOutline, addOutline, personOutline, peopleOutline, chevronDownOutline, caretUp, caretDown} from 'ionicons/icons';
import './Form.css';
import OpenMenuButton from "../../../components/OpenMenuButton";
import UserGroupPicker from "../../../components/UserGroupPicker";
import { useParams } from 'react-router';
import ServerService from '../../../services/Server';
//import { Environment } from "../../../data/Environment";
import Util from '../../../services/Util';
import NumberInput from '../../../components/NumberInput';
import ListBox from '../../../components/ListBox';
import moment from "moment"
import { format, parseISO, formatISO } from 'date-fns';
import { useForm, Controller } from 'react-hook-form';
import { GeoType } from '../../../services/Geo';
//import { disposeEmitNodes } from 'typescript';
import Upload from '../../../components/Upload';

const JSON5 = require("json5")

type FormParams = {
  id:string, 
  hid:any, 
  dummy:string
}

const Form: React.FC = () => {

  const { control, handleSubmit, formState:{errors}, clearErrors} = useForm({
    mode:'onSubmit'
  });

const {id, hid, dummy} = useParams<FormParams>();
const history = useHistory();

const [showLoading, setShowLoading] = useState(false);
const [showMsg, setShowMsg] = useState(false);
const [showBackdrop, setShowBackdrop] = useState(false);
const [cfgs, setCfgs] = useState<any>({});
const [atts, setAtts] = useState([]);
const [closers, setClosers] = useState([]);
const [relates, setRelates] = useState([]);
const [expandAtts, setExpandAtts] = useState(true);
const [expandTaskCloser, setExpandTaskCloser] = useState(true);
const [expandRelated, setExpandRelated] = useState(true);
const [info, setInfo] = useState({
  memoId:"",
  status:"",
  sepColor:"",
  inpLbl:"",
  attLbl:"",
  wLvl:""
});
const fileInput = useRef(null);

const [presentAlert] = useIonAlert();

const [tabs, setTabs] = useState([])
const [curTab, setCurTab] = useState("header")

const [curId, setCurId] = useState("")

const [inps, setInps] = useState({});

var refreshThreshold:any = 0

const [opened, setOpened] = useState(false)
const [formatId, setFormatId] = useState(0)
const [showActionSheet, setShowActionSheet] = useState(false)

const [pickerState, setShowPicker] = useState({ showPicker:false, title:'', list:'', notIn:[], firstTime:true})
const [listBoxState, setShowListBox] = useState({ showPicker:false, title:'', inp:null, id:null, inps:null, onChange:null})

const [togglePosition, setTogglePosition] = useState(false)
const [mandaGrps, setMandaGrps] = useState({})

const [sending, setSending] = useState(false)

const inpsRef = useRef(null)
const tabsRef = useRef(null)

inpsRef.current = inps
tabsRef.current = tabs

const server = new ServerService();
var state = server.state;

const util = new Util();

type FormType = { att: any, info:any, btn:any, tab:any , inps:any, aug:any, rug:any, cfg:any};

var goBack = false;
var btnClicked = "";
var handleOpened = false;

const okBtn = 
{
  side: 'end',
  icon: checkmarkCircle,
  text: 'OK',
  role: 'cancel',
  handler: () => {
    setShowLoading(false);
    console.log("OK goBack:"+goBack);
    if(goBack) {
      setShowMsg(false);
      goBack = false;
      history.replace("/page/home/workflows", {})
    }
  }
}

const refreshBtn = {
  text:'Refresh',
  icon: refreshOutline,
  handler: () => {
    setShowLoading(false);
    window.location.reload();
  }
}

const yesBtn = 
{
  role: 'yes',
  text: 'Yes',
  cssClass: 'confirm-alert-button-yes'
}

const noBtn = 
{
  role: 'no',
  text: 'No'
}

const isEditMode = () => {
  return (id !== "0") || (curId !== "")
}

const fetchTabs = async function() {
  console.log("fetchTabs()");
  const res = await doFetchTabs(state, formatId)

//  console.log("fetchTabs() setInps 1:"+Object.keys(res.inps).length)

  setInps(res.inps);
  setTabs(res.tab);
  setCfgs(res.cfg);

  /*
    process inps
  */
  if (res.inps) {
    const a = Object.keys(res.inps).map(async (key: any) => {
      const inp = util.getKeyValue(key)(res.inps)
      //console.log("  fetchTabs() -" + inp.field_name+":"+inp.value);

      if (inp.field_name.substring(0,2) !== "H_" && inp.src_url && inp.src_param && inp.src_param.indexOf("${")<=0) {
        return doHandleTrigger(inp, res.inps)
      }
    })

    Promise.all(a).then(() => {
      console.log("  fetchTabs() : update tabs")
      // console.log("  fetchTabs() : "+Object.keys(inps).length+" **********");
      // console.log("  fetchTabs() : "+Object.keys(res.inps).length+" **********");
      // console.log("  fetchTabs() setInps 2:"+Object.keys(res.inps).length)
      //tinps = inps
      //setInps(prevState => ({...prevState,...res.inps}));
      // const a = Object.keys(inps).map(async (key: any) => {
      //   const inp = util.getKeyValue(key)(inps)
      //   console.log("  -" + inp.field_name+":"+inp.value);
      // })
    
      setTabs(prevState => ([...prevState]))
//      setInps({...res.inps});
    })
  }

}

const BG_SET_VALUE = async (inp:any,value:any) => {
  inp.value = value

  await doHandleTrigger(inp,inpsRef.current)
}

const BG_FIELD = (fn:any) => {
//console.log("BG_FIELD("+fn+")")

  //console.log("  inps : "+Object.keys(inps).length);
  //console.log("  inpsRef : "+Object.keys(inpsRef.current).length);

  return util.BG_FIELD(inpsRef.current, fn)
}

const BG_PANEL = (pn:any) => {
  console.log("pn:"+pn) 

  var result:any = null

  tabsRef.current?.forEach((tab:any) => {
    if (result) {
      return
    }
    if (tab.id!=="upload" && tab.id!=="assign") {
      const panels = tab.panels

      result = util.BG_FIELD(panels, pn)
      console.log("result:"+result)
    }
  })
  
  return result
}

const handleFormOpen = async () => {
    console.log("handleFormOpen("+formatId+","+handleOpened+")")
    if (formatId!==0 && !handleOpened) {
      handleOpened = true;
      const script = await server.getScript("FO", formatId)
      eval("const _global = (window || global);"+script)
      console.log("handleFormOpen("+formatId+","+handleOpened+") : finish")
    }
}

useEffect(() => {
  console.log("Form : useEffect(formatId):"+formatId+","+opened+","+id);
  if (formatId !== 0 && (opened || !isEditMode())) {
      fetchTabs()
  }

  if (!opened) {
    handleFormOpen()
  }

  console.log("Form : End useEffect(formatId):"+formatId+","+opened+","+id);

},[formatId])

const refresh = () => {
  console.log("refresh()")
//  console.log("refresh() setInps 3.1:"+Object.keys(inps).length)
  // const b = Object.keys(tinps).map(async (key: any) => {
  //   const inp = util.getKeyValue(key)(tinps)
  //   console.log("  --" + inp.field_name+":"+inp.value);
  // })
  // console.log("refresh()-----")
  setInps(prevState => ({...prevState}));
//  console.log("refresh() setInps 3.2:"+Object.keys(inps).length)
}

const upload = (files:any) => {
  if (files.length>0) {
    setShowLoading(true);

    const formData = new FormData();
    formData.append("id",info.memoId);
    for(var i=0;i<files.length; i++) {
      const file = files[i]
      formData.append(file.name, file);
    }

    fetch(server.getPrefixUrl()+"memo/file/upload",server.uploadRequest(formData)
    ).then(
      response => response.json() // if the response is a JSON object
    ).then(res => {
      
      setShowLoading(false);
      if (res.success) {
        var newAtts:any[] = []
        for(var i=0;i<res.data.length;i++) {
          newAtts = [...newAtts, {
            nodeRef:res.data[i].nodeRef,
            path:res.data[i].path,
            name:res.data[i].name,
            desc:res.data[i].desc,
            action:res.data[i].action
          }];
        }
        setAtts([...atts, ...newAtts])
      } else {
        console.log(res.message);
      }
    }).catch(
      error => {
        setShowLoading(false);
        console.log(error) // Handle the error response object
      }
    );
  }
}

const editFile = (att:any) => {
  att.desc = "Test"

  setTabs(prevState => ([...prevState]))
}

const deleteFile = (att:any) => {
  console.log("deleteFile:"+att);
  var tmpAtts = atts

  const index = tmpAtts.indexOf(att)

  tmpAtts.splice(index,1)

  setAtts(tmpAtts)

  setTabs(prevState => ([...prevState]))
}

const deleteCloser = (ug:any) => {
  console.log("deleteCloser:"+ug);

  const index = closers.indexOf(ug)

  closers.splice(index,1)

  setTabs(prevState => ([...prevState]))
}

const deleteRelated = (ug:any) => {
  console.log("deleteRelated:"+ug);

  const index = relates.indexOf(ug)

  relates.splice(index,1)

  setTabs(prevState => ([...prevState]))
}

const loadDefaultUsers = async (id:any) => {
    const data = {p1:id}
    const res = await fetch(server.getFullUrl("srcUrl/main/approvalMatrixUserGroup", data),server.getRequest())
    .then(res => res.json()
    .then(res => {
        return res.data
    },
    (error) => {
        console.log("err 2");
        showError({msg:error})
    })
    )
    .catch(e => {
      console.log("err 1:"+e);
//      setErrColor("dark");//temp
      showError({msg:"Please check Internet Connection!",btns:[okBtn, refreshBtn]})
    })

    const aug = {
      u:res.ausr,
      g:res.agrp
    }
    fetch(server.getFullUrl("admin/main/userGroup/listDetail", aug),server.getRequest())
    .then(res => res.json()
    .then(res => {
        setClosers(res.data)
    },
    (error) => {
        console.log("err 2");
        showError({msg:error})
    })
    )
    .catch(e => {
      console.log("err 1:"+e);
      //setErrColor("dark");//temp
      showError({msg:"Please check Internet Connection!",btns:[okBtn, refreshBtn]})
    })

    const rug = {
      u:res.rusr,
      g:res.rgrp
    }
    fetch(server.getFullUrl("admin/main/userGroup/listDetail", rug),server.getRequest())
    .then(res => res.json()
    .then(res => {
        setRelates(res.data)
    },
    (error) => {
        console.log("err 2");
        showError({msg:error})
    })
    )
    .catch(e => {
      console.log("err 1:"+e);
      //setErrColor("dark");//temp
      showError({msg:"Please check Internet Connection!",btns:[okBtn, refreshBtn]})
    })
}

const processTabs = async function(res:any) {
  console.log("*** processTabs()")

  if (!res.success) {
    console.log("err 4");
    showError({msg:res.message,btns:[okBtn, refreshBtn]})
    return {};
  }

  // console.log("SHOW_FILES_TAB:"+res.data.cfg?.SHOW_FILES_TAB)
  // console.log("SHOW_ASSIGNMENT_TAB:"+res.data.cfg?.SHOW_ASSIGNMENT_TAB)

  var rtabs = res.data.tab
  var rtabs2: any[] = []

  var tmpMandaGrps : {[k:string]:any} = mandaGrps

  var inps2: any = {}

  rtabs.forEach((tab:any) => {
    var inps = tab.inp;
    if (inps) {
      var pnls:any = {"000":{display_name:res.data.info?.inpLbl, expand:true, hidden:false, inps:[]}};

      const tParam = JSON5.parse("{"+(tab.spc_param ? tab.spc_param : "")+"}");
      if (!tParam.hidden) {
         if (tParam.default) {
           console.log("set cur tab :"+tab.id)
           setCurTab(String(tab.id))
         }
      }

      inps.forEach((inp:any) => {

        if (inp.display_type === "P") {
          const name = inp.field_name;
          inp.expand = true;
          inp.inps = [];
          pnls[name] = inp;
        }
        else {
          const param = JSON5.parse("{"+inp.spc_param+"}");
          inp.valueFrom = param.valueFrom;
  
          if (inp.display_type === "C") {
            if (inp.value==="now") {
              inp.value = formatISO(new Date())
            }
            if (inp.value) {
              inp.formattedValue = format(parseISO(inp.value!), inp.display_format)
            }
          }
          else
          if (inp.display_type === "X" && param.mandaGrp) {
            if(!tmpMandaGrps[param.mandaGrp]) {
              tmpMandaGrps[param.mandaGrp] = {member:[],msg:"Please check at least one check box"}
            }
            tmpMandaGrps[param.mandaGrp].member.push(inp.field_name)
            if (param.mandaMsg) {
              tmpMandaGrps[param.mandaGrp].msg = param.mandaMsg
            }
          }
          inps2[inp.field_name] = inp;
        }

      })

      inps.forEach((inp:any) => {
        const prefix = inp.field_name.substring(0,2)
        //const inp = getKeyValue(key)(inps2)
  //          inps2.map((inp:any,i:any) => {
        if (inp.display_type !== "P" && inp.display_type !== "H") {
          //console.log("pass 1.4:"+inp.field_name)
          var pname = "000";
          if (inp.parent_name) {
            pname = prefix+inp.parent_name;
          }
          const panel = util.getKeyValue(pname)(pnls);
          panel.inps.push(inp.field_name);
          pnls[pname] = panel;
        }
      });

      //console.log("pass 1.3:");
      tab.panels = pnls
    }
      //console.log("tab 1 :"+tab.id+","+tab.title)

    rtabs2.push(tab);

  })

  Object.keys(tmpMandaGrps).forEach((key: any) => {
    console.log("mandaGrp.key:"+key)
  })
  setMandaGrps(tmpMandaGrps)

  //Promise.all(b).then(() => {
    if (!res.data.cfg?.SHOW_FILES_TAB || res.data.cfg?.SHOW_FILES_TAB === "1") {
      rtabs2.push({id:"upload",title:"Files"})
    }

    if (!res.data.cfg?.SHOW_ASSIGNMENT_TAB || res.data.cfg?.SHOW_ASSIGNMENT_TAB === "1") {
      rtabs2.push({id:"assign",title:"Assignment"})
    }
  //});
  if (!handleOpened) {
    handleFormOpen()
  }

  console.log("  processTabs() inps2.len: "+Object.keys(inps2).length+" **********");

  return {info:res.data.info, tab:rtabs2, inps:inps2, att:res.data.att, aug:res.data.aug, rug:res.data.rug, cfg:res.data.cfg}

}

const doFetchDtls = async function(state:any) {
  console.log("doFetchDtls()");

  var timeout = true;
  setTimeout(()=>{
    if (timeout) {
      console.log("err timeout");
//      setErrColor("dark");//temp
      showError({msg:"Please check Internet Connection!",btns:[okBtn, refreshBtn]})
    }
  },4000)
  
  if (!curId && id && id!=="0") {
    console.log("setCurId("+id+")")
    setCurId(id)
  }
  const data = {id:id,hid:hid}
  const res = await fetch(server.getFullUrl("mb/memo/get", data),server.getRequest())
  .then(res => res.json()
  .then(async res => {
        timeout = false;

      return await processTabs(res)
  },
  (error) => {
      timeout = false;
      console.log("err 2");
      showError({msg:error})
  })
  )
  .catch(e => {
    timeout = false;
    console.log("err 1:"+e);
//    setErrColor("dark");//temp
    showError({msg:"Please check Internet Connection!",btns:[okBtn, refreshBtn]})
  })

  const resAll = {...res} as FormType
  return resAll;
}

const handleTrigger = async (inp:any,inps:any,clearOld:boolean=false) => {
  console.log("handleTrigger()")
  refreshThreshold++

  var a:any

  if (inp.before_script) {
    eval(inp.before_script)
  }

  if (inp.trigger_field) {
    const tgrField = inp.trigger_field.split(",");
    tgrField.forEach(async (tgrName:string) => {
      const prefix = tgrName.substring(0,2)
      if (prefix !== "H_" && prefix !=="F_") {
        tgrName = "F_"+tgrName
      }
      console.log("  tgr:"+tgrName+" , inp:"+inp.field_name);
      const tgr:any = util.getKeyValue(tgrName)(inps);
      if (tgr) {
        if (clearOld) {
          tgr.value = null
          tgr.valueLabel = ''
        }
        a = await doHandleTrigger(tgr, inps);
      } else {
        console.log("    Not Found:");
        alert("Trigger Not Found : "+tgrName);
      }
    })
  }

  if (inp.after_script) {
    eval(inp.after_script)
  }

  refreshThreshold--
  console.log("refreshThreshold:"+refreshThreshold)
  if (refreshThreshold === 0) {
     refresh()
  }

  return a
}

const doHandleTrigger = async (tgr:any,inps:any) => {
  var a:any
  console.log("---doHandleTrigger("+tgr.field_name+"):srcUrl:"+tgr.src_url+", srcParam:"+tgr.src_param)

  if (tgr.src_url) {
        if(tgr.display_type === "R" || tgr.display_type === "L") {

          console.log("---tgr is Radio or List Box")
      
          tgr.opts = await server.listOptions(tgr,id,inps)
          if (!tgr.value && tgr.opts.length===1) {
            console.log("  after listOption():"+tgr.field_name)
            console.log("     opts.length==1")
            tgr.value = tgr.opts[0].id
  
            a = await handleTrigger(tgr, inps)
          }
  
          //console.log("inp.saveToField:"+inp.save_to_field)
          if (tgr.save_to_field === "format_id" && tgr.value) {
//              console.log("formatId:"+formatId+",inp.value:"+tgr.value)
              if (formatId!==tgr.value && formatId!==parseInt(tgr.value)) {
                if (!isEditMode() || (isEditMode() && formatId!==0)) {
                  setOpened(true)
                }
                console.log("setFormatId("+tgr.value+")")
                setFormatId(tgr.value)
              }
          }
  
          tgr.valueLabel = null
          for (var o in tgr.opts) {
            if ((tgr.value === tgr.opts[o].id) || (parseInt(tgr.value) === parseInt(tgr.opts[o].id))) {
              if (tgr.value !== "") {
                console.log("set valueLabel"+tgr.field_name+":"+tgr.opts[o].name)
                tgr.valueLabel = tgr.opts[o].name
              }
              break;
            }
          }

          //console.log("tgr:"+tgr.field_name+":"+tgr.value+":"+tgr.valueLabel)
  
          return tgr.opts;
          //setInps(prevState => ({...prevState}));

        } else {
          console.log("---tgr is not Radio and List Box")

          var srcUrl = tgr.src_url;
						
          if (srcUrl && srcUrl.substring(0,2) === "${") {
            console.log("srcUrl starts with ${")
            var pos2 = srcUrl.indexOf("}");
            var srcName = srcUrl.substring(2,pos2);
            
            var pfx = srcName.substring(0,2);
            if ((pfx !== "H_") && (pfx !== "F_")) {
              srcName = "F_" + srcName;
            }

            var f = util.getKeyValue(srcName.trim())(inps);
            var fv = "";
            if (!f) {
              alert("Field Not Found : "+srcName.trim());
            }
            else {
              fv = f.value;
            }							
          
            tgr.value = fv;
          
          } else {
            console.log("---srcUrl not starts with ${")

            const srcUrl = server.finalSrcUrl(tgr.src_url);
            const params = tgr.src_param.split(",");
            const finalParam = server.parseParams(params,id,inps)

            refreshThreshold++
            
            fetch(server.getFullUrl("srcUrl/"+srcUrl, finalParam),server.getRequest())
            .then(async (res) => {
              refreshThreshold--
              
              if (res.ok) {
                  const res2 = await res.json().then((res2) => {
                    return res2
                  })
                  
                  if (res2.success) {
                    
                    var pfx = tgr.field_name.substring(0,2);
                    //console.log(result.data)
                    var dataArray = res2.data;
                    //console.log(dataArray.length)
                    if (dataArray.length > 0) {
                        //console.log("pfx:"+pfx+",savetofield:"+tgr.save_to_field)
                        if (pfx === "H_" && (tgr.save_to_field === "approval_matrix_id")) {
                          if (dataArray.length > 1) {
                            // show error
                            //BG.Dlg.error(null, MODULE_MEMO, {msg:"Found "+dataArray.length+" Approval Matrixes! Please contact administrator"});
                            console.log("Found "+dataArray.length+" Approval Matrixes! Please contact administrator");
                            tgr.value = null;
                            //me.getBtnApprovalMatrix().hide();

                          } else {
                          
                            tgr.value = dataArray[0].id;
                          //  me.getBtnApprovalMatrix().show();
                          //  me.getBtnApprovalMatrix().fid = f.value;
                            loadDefaultUsers(tgr.value);

                            a = await handleTrigger(tgr, inps)
                          }

                        } else if (tgr.display_type==="D") {
                          // var hid = parent.down("field[name="+field.name+"_h]");
                          // if (dataArray[0].id) {
                          //   field.bgData.value = dataArray[0].id;
                          //   field.bgData.v = dataArray[0].id;
                          //   field.show();
                            
                          //   hid.setValue(dataArray[0].id);
                          // }
                          // else {
                          //   field.hide();
                          //   hid.setValue(null);
                          // }
                          
                        } else {
                          var isDirty = tgr.value !== dataArray[0].id
                          if (isDirty) {
                            tgr.value = dataArray[0].id;
                            //console.log("-----tgr.field_name:"+tgr.field_name+":"+tgr.value)
                            a = await handleTrigger(tgr, inps)
                            
                            // if (refreshThreshold==0) {
                            //   refresh()
                            // }
                          }
                        }
                    } else {
                      tgr.value = null;
                      if (pfx === "H_" && (tgr.save_to_field === "approval_matrix_id")) {
                        // me.getBtnApprovalMatrix().hide();
                        // me.getBtnApprovalMatrix().fid = null;
                      }
                    }
                  }
              }
            })
          }
        }
    }

    return a
}

const callSrcUrl = async (inp:any, inps:any) => {

  console.log("callSrcUrl():"+inp.src_url+", param:"+inp.src_param)

  if (inp.src_url) {
    if (inp.display_type === "R" || inp.display_type === "L") {
      
        inp.opts = await server.listOptions(inp,id,inps)

        if (!isEditMode()) {
          if (!inp.value && inp.opts.length===1) {
            inp.value = inp.opts[0].id
            handleTrigger(inp, inps)
          }
        }

        for (var o in inp.opts) {
          if ((inp.value === inp.opts[o].id) || (parseInt(inp.value) === parseInt(inp.opts[o].id))) {
            inp.valueLabel = inp.opts[o].name
            break;
          }
        }

        if (inp.save_to_field === "format_id" && inp.value && !formatId) {
          setFormatId(parseInt(inp.value))
        }

        return inp.opts;
    }

  }
}

const fetchDtls = async function() {
  console.log("fetchDtls()");
  setTabs([]);
  setInfo({
    memoId:"",
    sepColor:"",
    inpLbl:"",
    attLbl:"",
    status:"",
    wLvl:""
  });
  setAtts([]);
  setInps({});
  setCfgs({});

  const res = await doFetchDtls(state);

  setInfo(res.info);
  setAtts(res.att);
  //console.log("fetchDtls() setInps 4:"+Object.keys(res.inps).length)
  
  setInps(res.inps);
  setTabs(res.tab);
  setCfgs(res.cfg);

  setClosers(res.aug);
  setRelates(res.rug);

  /*
    process inps
  */
  if (res.inps) {
    //console.log("   fetchDtls():inps.length:"+Object.keys(res.inps).length)
    const a = Object.keys(res.inps).map(async (key: any) => {
      const inp = util.getKeyValue(key)(res.inps)
        //console.log("  -" + inp.field_name+":"+inp.value);

      /*
        load list box or radio options
      */
      if (inp.src_url &&
            ((!isEditMode() && inp.src_param && inp.src_param.indexOf("${")<=0) ||
            isEditMode())
        ) {
        return callSrcUrl(inp, res.inps)
      }
    })

    Promise.all(a).then(() => {
      console.log("  fetchDtls:update tabs")
      setTabs(prevState => ([...prevState]))
    })
  }
}

const doFetchTabs = async function(state:any, fid:any) {
  console.log("doFetchTabs("+fid+")");

  var timeout = true;
  setTimeout(()=>{
    if (timeout) {
      console.log("err timeout");
//      setErrColor("dark");//temp
      showError({msg:"Please check Internet Connection!",btns:[okBtn, refreshBtn]})
    }
  },4000)

  const data = {id:fid,hid:hid}
  const res = await fetch(server.getFullUrl("mb/memo/format/get", data),server.getRequest())
  .then(res => res.json()
  .then(async res => {
        console.log("***fetch format");
        timeout = false;

        const r = await processTabs(res)

        var fTab = r.tab
        fTab.splice(0,1)

        var hTab = tabs;
        while(hTab.length>1) {
          hTab.splice(1,1)
        }

        const nTab = [...hTab, ...fTab]

        // Object.keys(r.inps)?.map((key:any) => {
        //   const inp = util.getKeyValue(key)(r.inps)
        //   if (inp.field_name.startsWith("F_")) {
        //     setInps(prevState => ({...prevState, [inp.field_name]:inp}))
        //   }
        // })

        Object.keys(inps)?.forEach((key:any) => {
          const inp = util.getKeyValue(key)(inps)
          if (inp.field_name.startsWith("H_")) {
            r.inps[inp.field_name] = inp
          }
        })

        //console.log("  doFetchTabs() : r.inps:"+Object.keys(r.inps).length+" **********");

        return {info:r.info, tab:nTab, inps:r.inps, att:[], aug:[], rug:[], cfg:r.cfg}
  },
  (error) => {
      timeout = false;
      console.log("err 2");
      showError({msg:error})
  })
  )
  .catch(e => {
    timeout = false;
    console.log("err 1:"+e);
    //setErrColor("dark"); //temp
    showError({msg:"Please check Internet Connection!",btns:[okBtn, refreshBtn]})
  })

  //console.log("  doFetchTabs() : inps.len:"+Object.keys(inps).length+" **********");

  const resAll = {...res} as FormType
  return resAll;
}

useEffect(() => {
  console.log("Form : useEffect(dummy):"+opened+",lastUrl:"+server.lastUrl);
  if (!state.base64ticket) {
      server.login(async () => {
        state = server.state;
        fetchDtls();
      });
  } else {
    fetchDtls();
  }

  console.log("Form : End useEffect(dummy):"+opened);

}, [dummy])

const getHSaveField = (saveField:string) => {
  var field:any = null

  console.log("getHSaveField("+saveField+")")
  Object.keys(inps).map((key: any) => {
    const inp = util.getKeyValue(key)(inps)
    console.log("-"+inp.save_to_field)
    if (inp.save_to_field === saveField) {
      console.log("  Found")
      field = inp
    }
  })

  return field
}

const getHSaveFieldValue = (saveField:string, req:boolean) => {
  var field = getHSaveField(saveField)
  var v = null;
  if(field) {
    v = field.value
    if (field.valueFrom) {
      var vField = util.getKeyValue(field.valueFrom)(inps);
      if (vField) {
        field.value = vField.value;
        v = vField.value;
      } else {
        alert("Invalid Field Name : valueFrom="+field.valueFrom)
        setShowLoading(false)
      }
    }
  }
  else {
    if (req) {
      alert("Field Not Found : "+saveField);
      setShowLoading(false)
      throw "fnf";
    }
  }
  return v;
}

const getFieldValues = () => {
  var fields:any[] = []
  Object.keys(inps).map((key: any) => {
    const inp = util.getKeyValue(key)(inps)
//    console.log("-"+inp.field_name)
    if (inp.field_name.indexOf("F_") === 0) {
      fields.push(inp)
    }
  })

  var values = [];

  for(var i=0; i<fields.length; i++) {
    var f = fields[i];
    
    if (f.display_type === "R") {
//      if (f.checked) {
        values.push({
          n:f.field_name.substring(2),
          v:f.value,
          d:f.display_type,
          p:f.src_url === "main/pdpa/subject/attribute"
        });
//      }
    } else {
      if (f.display_type!=="B") {
        var n = f.field_name.substring(2);
        n = n.indexOf("_h")>=0 ? n.substring(0,n.length-2) : n;
        var hValue = "";
        var value = "";
        var pValue = "";
        // if (f.bgData.hiddenValue) {
        //   var hField = this.getMainForm().down("field[id=_"+f.id+"]");
        //   hValue = "|"+hField.getValue();
           if (f.display_type==="U" && !f.value?.startsWith("|||UPLOAD|")) {
                f.value = "|||UPLOAD||"
            //  pValue = "|||UPLOAD|";
            //  hValue = "|"+f.value;
           } else 
           if (f.display_type==="C") {
              console.log(f.field_name+":display_type=C:"+f.value)
              if (f.value === "Invalid date") {
                f.value = ""
              }
              if (f.value!==null && f.value !== "null" && f.value!=="") {
                //var date = new Date(f.value).toJSON()
                //pValue = date ? date.substring(0, 19) : date
                pValue = moment(f.value).format("YYYY-MM-DDTHH:mm:ss")
                if (pValue === "Invalid date") {
                  pValue = ""
                }
                value = ""
                hValue = ""
              }
              console.log("pValue:"+pValue)
           }
        // }
        values.push({
          n:n,
          v:(f.value===null || f.value === "null") ? "" : (pValue ? pValue + value + hValue : f.value),
          d:f.display_type,
          p:f.src_url === "main/pdpa/subject/attribute"
        });
      }
    }
  }
  
  return JSON.stringify(values);
}

const listFiles = () => {
  var values:any[] = [];

  atts?.map((att,i) => {
    values.push({
      name:att.name,
      path:att.path ? att.path : "",
      nodeRef:att.nodeRef ? att.nodeRef : "",
      desc:att.desc
    });
  })

  return JSON.stringify(values);
}

const prepareParams = () => {

    var v

    var params: any = {
      "id":curId,
      "hId":hid,
      "format_id":getHSaveFieldValue("format_id", true),
      "workflow_id":getHSaveFieldValue("workflow_id", true),
      "approval_matrix_id":getHSaveFieldValue("approval_matrix_id", true),
      "content1":"",
      "dtls":getFieldValues(),
      "status":info.status,
      "m":"1"
    }

    for(var i=1; i<=10; i++) {
      v = getHSaveFieldValue("field"+i, false)
      params["field"+i] = v ? v : ""
    }

    v = getHSaveFieldValue("remark", false)
    params.remark = v ? v : ""
    v = getHSaveFieldValue("requested_time", false)
    if (v) params.requested_time = v.replace(" ","T")

    params.aug = JSON.stringify(closers);
    params.rug = JSON.stringify(relates);
    params.files = listFiles();

    server.state = {...server.state}

  return params
}

const getLocation = () => {

  server.getLocation(null).then((l: GeoType) => {

    const loc = l.lat+","+l.lon;

    console.log("=======")
    console.log("loc:"+loc)
    console.log("=======")

    doSend(loc)

  });
}

const doSend = async (loc:any) => {
    console.log("doSend():lastUrl:"+server.lastUrl)

    const script = await server.getScript("BFN", formatId)
    eval(script)

    let params = prepareParams()

    if (loc) {
      params.loc = loc;
      params.locDtl = window.navigator.platform+","+window.navigator.userAgent;
    }
  
    fetch(server.getPrefixUrl()+"memo/send",
        server.postRequest(params,{'Bg-Source':'Mobile'})
      ).then(
      response => response.json() // if the response is a JSON object
    ).then(async res => {
      if (res.success) {
        console.log("success")

        const script = await server.getScript("FN", formatId)
        eval(script)
    
        setCurId(res.data.id)
        setSending(true)
        setShowBackdrop(true)
        setShowMsg(true)
        setShowLoading(false)
      } else {
        if (!res.data) {
          showError({msg:res.message})
        }
        else
        if (!res.data.valid) {
          console.log("!success:"+res.data.valid+":"+res.data.msg);
          const msg = res.data.msg;
          if (msg.startsWith("|BG_ERR|")) {
            showError({msg:msg.substring("|BG_ERR|".length)})
          } else {
            showError({msg:msg})
          }

          // if (res.message.indexOf("the task doesnt exist")>=0) {
          //   console.log("go back");
          //   goBack = true;
          // }
        }
      }
    }).catch(
      error => {
        setShowLoading(false);
        console.log(error) // Handle the error response object
      }
    )
}

const showError = (opt:any) => {
  setShowLoading(false);
  presentAlert({
    header: 'Error',
    message: opt.msg,
    buttons: opt.btns ? opt.btns : [okBtn],
    backdropDismiss: false
  })
}

const confirmSend = () => {
  presentAlert({
    header: 'Send for Approval?',
    buttons: [noBtn,yesBtn],
    backdropDismiss: false,
    onDidDismiss(ev) {
      if (ev.detail.role === "yes") {
        form.dispatchEvent(new Event("submit", {cancelable: true, bubbles: true}))
      }
    }
  })
}

const confirmCancel = () => {
  presentAlert({
    header: 'Cancel?',
    buttons: [noBtn,yesBtn],
    backdropDismiss: false,
    async onDidDismiss(ev) {
      if (ev.detail.role === "yes") {
        const script1 = await server.getScript("BFC", formatId)
        eval(script1)
      
        goPrevious()

        const script2 = await server.getScript("FC", formatId)
        eval(script2)
      }
    }
  })
}

const sendForApproval = () => {
  console.log("Send for Approval")
  setShowLoading(true);
  
  let params: any = {
    "amId":getHSaveFieldValue("approval_matrix_id", true),
    "tname":"requester"
  }

  fetch(server.getPrefixUrl()+"memo/saveLocation",
        server.postRequest(params,{})
      ).then(
        response => response.json() // if the response is a JSON object
        ).then(res => {
          if (res.success) {
            if(res.data.saveLocation) {
              getLocation()
            } else {
              doSend(null)
            }
          }
        }).catch(
          error => {
            // setShowLoading(false);
            // console.log(error) // Handle the error response object
//            console.log("doSend missing /saveLocation")
            doSend(null)
        }
        )

  
}

const saveDraft = async () => {
  await setShowLoading(true);

  const script = await server.getScript("BFS", formatId)
  eval(script)

  let params = prepareParams()
  
  await fetch(server.getPrefixUrl()+"memo/save",
      server.postRequest(params,{'Bg-Source':'Mobile'})
    ).then(
    response => response.json() // if the response is a JSON object
  ).then(async res => {
    if (res.success) {
      console.log("success")
    
      setCurId(res.data.id)
      setSending(false)
      setShowMsg(true);
      setShowLoading(false);

      const script = await server.getScript("FS", formatId)
      eval(script)
    } else {
      console.log("!success:"+res.message);

      if (res.message.indexOf("the task does not exist")>=0) {
        console.log("go back");
        goBack = true;
      }

      if (res.message.startsWith("|BG_ERR|")) {
        showError({msg:res.message.substring("|BG_ERR|".length)})
      } else {
        showError({msg:res.message})
      }

    }
  }).catch(
    error => {
      setShowLoading(false);
      console.log(error) // Handle the error response object
    }
  )
}

const isReadOnly = (param:any, inp:any) => {
  const mode = ","+param.readOnly+","
//  console.log("isReadOnly():"+param.readOnly+":"+mode+":"+info.status+":"+info.wLvl)
  return (!isEditMode() && (mode.indexOf("C") >= 0))
          || 
         (isEditMode() && 
            (
              (info.status==="D" && mode.indexOf("E") >= 0) ||
              (info.status==="R" && info.wLvl==="0" && mode.indexOf("R") >= 0) ||
              (info.status!=="D" && info.wLvl!=="0" && mode.indexOf(","+info.wLvl+",") >= 0)
            )
         )
}

const validateForm = () => {
  console.log("validateForm")
 
  var result = true;

  Object.keys(mandaGrps).map((key: any) => {
    const grp = util.getKeyValue(key)(mandaGrps)
    console.log("  -" + key + ":"+grp.member+":"+grp.msg);

    if (result) {
      if (grp.member.length > 0) {
        var checked = false

        grp.member.forEach((mem: any) => {
          const inp = util.getKeyValue(mem)(inps)
          //console.log("   inp.name:"+inp.field_name+", checked:"+checked+", inp:"+inp.value)
          if (!checked && inp.value) {
            checked = true
          }
        })

        if (!checked) {
          result = checked
          showError({msg:grp.msg})
        }
      }
    }

  })

  console.log("result:"+result)
  return result
}

const onSubmit = (data:any) => {
  console.log("onSubmit()")
  // for(var a in data) {
  //   console.log("- data["+a+"]:"+data[a])
  // }
  if(validateForm()) {
    if (btnClicked==="send") {
      sendForApproval()
    } else {
      saveDraft()
    }
  }
  return false
}

const hisLoc = history.length
const goPrevious = () => {
  history.go(hisLoc-history.length-1)
}

const goLastUrl = () => {
  console.log("goLastUrl():"+server.lastUrl)
  history.replace(server.lastUrl, {})
}

const mergeTextField = (panel:any,inp:any,param:any,style:any,istyle:any,ctrlRules:any,labelMap:any,i:any,ro:any) => {
  var field

  //console.log("mergeText() : "+inp.field_name+":"+param.type)

  if (inp.field_type==="I" || inp.field_type==="F") { // numeric
    const df = inp.display_format?.split("|")
    field = (
      <><IonLabel className="ion-text-wrap" position="floating">
      <span dangerouslySetInnerHTML={{__html: labelMap.label}}></span>
      </IonLabel>
        <Controller
          name={inp.field_name}
          control={control}
          rules={ctrlRules}
          defaultValue={inp.value}
          render={({field:{onChange, onBlur, value}}) => (
            <NumberInput
              prefix={df.length>3 ? df[3] : undefined}
              suffix={df.length>4 ? df[4] : undefined}
              thousandSeparator={df.length>1 ? df[1] : ","}
              fixedDecimalScale={df.length>2 && parseInt(df[2])>0}
              decimalSeparator={df.length>2 && parseInt(df[2])>0 ? "." : undefined}
              decimalScale={df.length>2 ? df[2] : undefined}
              allowNegative={df.length>0 && df[0]}
              readonly={ro}
              onIonChange={
                (r: any) => {
                    // for(var a in r) {
                    //   console.log("=r["+a+"]:"+r[a])
                    // }
                    inp.value = r.value
                    onChange(r)
//                                        inp.value = r.formattedValue;
                    handleTrigger(inp, inps)
                    setTabs(prevState => ([...prevState]))
                    
                }
              }
              value={inp.value}
            />
          )}
        />
        {
          errors[inp.field_name] && <div className="error">Please Enter {inp.display_name}</div>
        }
      </>
    )
  } else { // string
    field = (
        <Controller 
          name={inp.field_name}
          control={control}
          rules={ctrlRules}
          defaultValue={inp.value}
          render={({field:{onChange, onBlur, value}}) => (
            <IonInput 
              name={inp.field_name}
              onIonChange={(e:any) => {
                inp.value = e.target.value;
                // for(var a in e.detail) {
                //   console.log("--"+a+":"+util.getKeyValue(a)(e.detail))
                // }
                // console.log("class:"+e.constructor.name)
                onChange(e)
                handleTrigger(inp, inps)
              }}
              onIonBlur={onBlur}
              onFocus={() => {clearErrors(inp.field_name)}}
              type={param.type ? param.type : "text"}
              value={inp.value}
              required={inp.is_mandatory}
              maxlength={inp.field_length ? inp.field_length : undefined}
              debounce={1000}
              readonly={ro}
              style={style}
              aria-label={labelMap.label}

              labelPlacement="floating"
              className={`${errors[inp.field_name] && 'ion-invalid'} ion-touched`}
            >
              <span slot="label" className="ion-text-wrap" dangerouslySetInnerHTML={{__html: labelMap.label}}></span>
            </IonInput>
          )}
        />
    )
  }
  return field
}

const mergeTextArea = (panel:any,inp:any,param:any,style:any,ctrlRules:any,labelMap:any,i:any,ro:any) => {
  style.minHeight = (inp.display_height ? inp.display_height : 150)+"px"
  style.height = (inp.display_height ? inp.display_height : 150)+"px"
  //console.log("inp.display_height:"+inp.display_height)
  var field = (
      <Controller
        name={inp.field_name}
        control={control}
        rules={ctrlRules}
        defaultValue={inp.value}
        render={({field:{onChange, onBlur, value}}) => (
          <IonTextarea style={style} required={inp.is_mandatory} maxlength={inp.field_length ? inp.field_length : undefined} readonly={ro}
          rows={param.rows ? param.rows : undefined} cols={param.cols ? param.cols : undefined}
          name={inp.field_name}
          onIonChange={onChange}
          onIonBlur={onBlur}
          onFocus={() => {clearErrors(inp.field_name)}}
          value={inp.value}
          onIonInput={(e:any) => {
              inp.value = e.target.value;
              handleTrigger(inp, inps)
//                        setInps(prevState => ({...prevState, [e.target.name]:e.target.value}))
          }}
          labelPlacement="floating"
          className={`${errors[inp.field_name] && 'ion-invalid'} ion-touched`}
          >
            <span slot="label" className="ion-text-wrap" dangerouslySetInnerHTML={{__html: labelMap.label}}></span>
          </IonTextarea>
        )}
      />
  )
  return field
}

const mergeListBox = (panel:any,inp:any,param:any,style:any,istyle:any,ctrlRules:any,labelMap:any,i:any,ro:any) => {
  //console.log("-"+inp.field_name+",value:"+inp.value+",valueLabel:"+inp.valueLabel)
  var field = (
      <Controller 
          name={inp.field_name}
          control={control}
          rules={ctrlRules}
          defaultValue={inp.value}
          render={({field:{onChange, onBlur, value}}) => (
    <>
    <IonItem key={i} className="itemAccordion" style={istyle} onClick={(e) => {
          setShowListBox({showPicker:true, title:inp.display_name, inp:inp, id:curId, inps:inps, onChange:onChange})
          //listBoxState = {showPicker:true, title:inp.display_name, inp:inp, id:id, inps:inps}
          //setShowListBoxPicker(true)
          e.stopPropagation()
    }}>
            <IonInput 
              readonly={true}
              name={inp.field_name}
              onIonChange={(e) => {
                 console.log("listbox onIonChange("+e+") "+inp.field_name+" "+e.target+","+inp.valueLabel+","+inp.value+","+value)
                 onChange(e)
                 handleTrigger(inp, inps)
              }}
              style={style}
              className={`${errors[inp.field_name] && 'ion-invalid'} ion-touched`}
              value={inp.valueLabel ? inp.valueLabel : null}
              onIonBlur={onBlur}
              onFocus={() => {clearErrors(inp.field_name)}}
              labelPlacement="floating"
              >
              <span slot="label" className="ion-text-wrap" dangerouslySetInnerHTML={{__html: labelMap.label}}></span>
            </IonInput>
            <IonIcon slot="end" icon={chevronDownOutline}></IonIcon>
            </IonItem>
    {
        errors[inp.field_name] && <IonItem key={inp.field_name+"_err"}><IonLabel color="danger">{param.errorText ? param.errorText : "Please Select Value"}</IonLabel></IonItem>
    }
    </>
          )}
          />
 )

  return field
}

const mergeCheckBox = (panel:any,inp:any,param:any,style:any,istyle:any,ctrlRules:any,labelMap:any,i:any,ro:any) => {
  var field = (
    <IonToggle checked={inp.value===true ? inp.value : (inp.value === "" ? false : inp.value)} name={inp.field_name} disabled={ro}
        onIonChange={(e:any) => {
          inp.value = e.detail.checked;
          if (param.require) {
            const reqs = param.require.split(",")
            reqs.forEach((rname:any) => {
                const rinp = util.getKeyValue(rname)(inps)
                rinp.is_mandatory = e.detail.checked
                if (!rinp.is_mandatory) {
                  if(errors[rinp.field_name]) {
                    delete errors[rinp.field_name]
                  }
                }
            })
            //setInps(prevState => ({...prevState}))
          }
          handleTrigger(inp, inps)
//                          setInps(prevState => ({...prevState, [e.target.name]:e.detail.checked ? e.detail.checked : false}))
        }}
        labelPlacement="end" justify="start"
    >
    <span className="wrap-label-radio-span">{inp.display_name}</span>
    </IonToggle>
  )
  return field
}

const mergeRadio = (panel:any,inp:any,param:any,ctrlRules:any,labelMap:any,i:any,ro:any) => {

  var field:any = ("")

  if (panel.expand) {
    var options:{}[] = [];
    inp.opts?.forEach((d:any,inx:any) => {
        options.push(
          <IonItem lines="none" key={inx}>
          <IonRadio labelPlacement="end" justify="start" mode="md" value={d.id} disabled={ro}>
              <span className={`wrap-label-radio-span ${errors[inp.field_name] && 'error'}`}>{d.name}</span>
          </IonRadio>
          </IonItem>
        );
    })

    if (options.length>0) {
      field = (
        <Controller
              name={inp.field_name}
              control={control}
              rules={ctrlRules}
              defaultValue={inp.value}
              render={({field:{onChange, onBlur, value}}) => (<>
                <IonLabel className="ion-text-wrap" color={inp.is_mandatory ? "danger" : "dark"}>
                    <span dangerouslySetInnerHTML={{__html: labelMap.label}}></span>
                </IonLabel>
                <IonRadioGroup key={i} allowEmptySelection={!inp.is_mandatory} className="itemAccordion"
                  onIonChange={async (e:any) => {
                    inp.value = e.detail.value;
                    console.log("radio change:"+inp.field_name+":"+e.detail.value)
                    onChange(e)
                    handleTrigger(inp, inps)
                    //setRefreshScr(!refreshScr)
  //                        setInps(prevState => ({...prevState, [e.target.name]:e.detail.value}))
                  }}
                  name={inp.field_name}
                  onChange={onChange}
                  onBlur={onBlur}
                  value={inp.value}
                  >
                  <>
                  {options}
                  </>
                </IonRadioGroup>
                {
                  errors[inp.field_name] && <IonItem key={inp.field_name+"_err"}><IonLabel color="danger">{param.errorText ? param.errorText : "Please Select a Value"}</IonLabel></IonItem>
                }
              </>)}
        />
      )
    }
  }
  return field
}

const mergeCalendar = (panel:any,inp:any,param:any,style:any,istyle:any,ctrlRules:any,labelMap:any,i:any,ro:any) => {
  
//  const now = (new Date()).toISOString()
  const now = formatISO(new Date())
//  console.log("mergeCalendar() : "+inp.field_name+":"+inp.value)
//  console.log("mergeCalendar() : now : "+now)

  var field = (
    <>
    <IonItem key={i} className="itemAccordion" id={"it_"+inp.field_name} style={istyle}>
    <Controller
          name={inp.field_name}
          control={control}
          rules={ctrlRules}
          defaultValue={inp.value}
          render={({field:{onChange, onBlur, value}}) => (<>
            <IonInput labelPlacement="floating" readonly={true} value={ inp.formattedValue ? inp.formattedValue : undefined} 
                  style={style} required={inp.is_mandatory}
                  className={`${errors[inp.field_name] && 'ion-invalid'} ion-touched`}
                  >
              <span slot="label" className="ion-text-wrap span-down" dangerouslySetInnerHTML={{__html: labelMap.label}}></span>
            </IonInput>
            <IonIcon className="listbox-button" slot="end" icon={chevronDownOutline}></IonIcon>
            <IonModal className="datetime-modal" trigger={"it_"+inp.field_name}><IonContent>
              <IonDatetime
                  readonly={ro}
                  onIonChange={(e:any) => {
                    clearErrors(inp.field_name)
                    inp.value = e.detail.value;
                    console.log("date e.detail.value:"+e.detail.value)
                    inp.formattedValue = format(parseISO(inp.value!), inp.display_format)
                    onChange(e)
                    handleTrigger(inp, inps)

                    //setInps(prevState => ({...prevState, [e.target.name]:e.detail.value}));
                  }}
                  name={inp.field_name}
                  onIonBlur={onBlur}
                  value={inp.value ? inp.value : now}
                  showDefaultButtons={param.showButtons ? param.showButtons : true}
                  showDefaultTitle={param.showTitle ? param.showTitle : false}
                  hourCycle={param.hourCycle ? param.hourCycle : "h23"}
                  firstDayOfWeek={param.firstDayOfWeek ? param.firstDayOfWeek : 0}
                  presentation={param.presentation ? param.presentation : undefined}
                  preferWheel={param.wheel ? param.wheel : false}
                  doneText={param.doneText ? param.doneText : "Done"}
                  cancelText={param.cancelText ? param.cancelText : "Cancel"}
              >
                  {param.title ?
                    <span slot="title">{param.title}</span>
                  :""}
                  {param.timeLabel ?
                    <span slot="time-label">{param.timeLabel}</span>
                  :""}
              </IonDatetime></IonContent>
            </IonModal>
          </>)}
    />
    </IonItem>
    {
      errors[inp.field_name] && <IonItem><IonLabel color="danger">{param.errorText ? param.errorText : "Please Enter a Value"}</IonLabel></IonItem>
    }
    </>
  )
  return field
}

const mergeUpload = (panel:any,inp:any,param:any,style:any,istyle:any,ctrlRules:any,labelMap:any,i:any,ro:any) => {
  var field = (
    <Controller
          name={inp.field_name}
          control={control}
          rules={ctrlRules}
          defaultValue={inp.value}
          render={({field:{onChange, onBlur, value}}) => (
            <Upload readonly={ro}
                    memoId={id}
                    server={server}
                    inp={inp}
                    label={labelMap.label}
                    param={param}
                onChange={
                  (r: any) => {
                      inp.value = r.value
                      console.log("upload:"+inp.field_name+":"+inp.value)
                      onChange(r)
                      handleTrigger(inp, inps)
                      setTabs(prevState => ([...prevState]))
                  }
                }
                onError={
                  (r: any) => {
                      showError({msg:r.msg})
                  }
                }
            /> 
          )}
    />
  )
  return field
}

const mergeLabel = (labelMap:any) => {
  var field = (
    <IonText>
      <span dangerouslySetInnerHTML={{__html: labelMap.label}}></span>
    </IonText>
  )

  return field
}

var form:any;
var inputs: {}[];

  return (
    <IonPage>
      <IonBackdrop visible={showBackdrop}></IonBackdrop>

      <IonHeader>
        <IonToolbar key={1}>
          <IonButtons slot="start">
            <IonMenuButton />
            <OpenMenuButton />
          </IonButtons>
          <IonTitle>{isEditMode() ? (curId!=="" ? curId : id) : "<New Workflow>"}</IonTitle>

        </IonToolbar>

        <IonToolbar key={2}>
          <IonSegment key={2} mode="md" value={curTab} scrollable={true} onIonChange={async e => {
              console.log(e.detail.value+":"+curTab)
              if (curTab !== e.detail.value) {
                setCurTab(String(e.detail.value));
              }
            }}>
            {tabs?.map((tab:any,i:any) => {
                const tParam = JSON5.parse("{"+(tab.spc_param ? tab.spc_param : "")+"}")
                console.log("tab:"+tab.id+","+tParam.hidden+","+tParam.default)
                if (!tParam.hidden) {
                  return (
                    <IonSegmentButton key={i} value={tab.id}><IonLabel><h2><strong>{tab.title}</strong></h2></IonLabel></IonSegmentButton>
                  )
                }
                return ""
            })}
          </IonSegment>
        </IonToolbar>

      </IonHeader>

      <IonContent>
          <IonFab horizontal={server.state.handed==="right" ? "end" : "start"} vertical={togglePosition ? "top" : "bottom"} slot="fixed">
            <IonFabButton color="light">
              <IonIcon icon={playOutline}></IonIcon>
            </IonFabButton>
            <IonFabList side={togglePosition ? "bottom" : "top"}>
              <IonFabButton color="danger" onClick={async () => {
                  confirmCancel()
                }}>
                <IonIcon size="large" icon={closeCircle}></IonIcon>
              </IonFabButton>
              <IonFabButton color="light" onClick={() => {setTogglePosition(!togglePosition)}}>
                <IonIcon size="large" icon={togglePosition ? caretDown : caretUp}></IonIcon>
              </IonFabButton>
            </IonFabList>
            <IonFabList side={server.state.handed==="right" ? "start" : "end"}>
              <IonFabButton color="success" onClick={() => {
                  console.log("sendForApproval")

                  btnClicked = "send"

                  confirmSend()
                  //form.dispatchEvent(new Event("submit", {cancelable: true, bubbles: true}));
                }}>
                <IonIcon size="large" icon={checkmarkCircle}></IonIcon>
              </IonFabButton>
              <IonFabButton color="primary" onClick={() => {
                  console.log("saveDraft")

                  btnClicked = "save"

                  clearErrors()

                  form.dispatchEvent(new Event("submit", {cancelable: true, bubbles: true}));
                }}>
                <IonIcon size="large" icon={saveOutline}></IonIcon>
              </IonFabButton>
              <IonButton color="warning" onClick={() => setShowActionSheet(true)}>
                <IonLabel>More...</IonLabel>
              </IonButton>
            </IonFabList>
          </IonFab>

          <IonActionSheet key="actSheet1" header="More Action"
              isOpen={showActionSheet}
              onDidDismiss={() => setShowActionSheet(false)}
              buttons={[{
                text:'Preview',
                icon: documentText,
                handler: () => {
                  setShowLoading(true);
                  console.log("preview "+id)
          
                  const params: any = prepareParams()
          
                  fetch(server.getPrefixUrl()+"memo/preview",server.postRequest(params,{})).then(
                    response => response.json() // if the response is a JSON object
                  ).then(res => {
                    setShowLoading(false);

                    if (res.success) {
                      window.open(server.getPrefixUrl()+"memo/preview?id="+res.data[0].id+"&c=force&noCache="+new Date()+"&a=false&alf_ticket="+server.state.ticket);
                    } else {
                      console.log(res.message);
                    }
                  }).catch(
                    error => {
                      setShowLoading(false);
                      console.log(error) // Handle the error response object
                    }
                  );
                }
              },{
                text:'Toggle Position',
                icon:togglePosition ? caretDown : caretUp,
                handler: () => {
                  setTogglePosition(!togglePosition)
                }
              }]}
          >
            
          </IonActionSheet>

          <form onSubmit={handleSubmit(onSubmit)} ref={ref => {form = ref}} id="frmMain">
          {tabs?.map((tab:any,i:any) => {
              if (curTab===tab.id || curTab===String(tab.id)) {
              const tParam = JSON5.parse("{"+(tab.spc_param ? tab.spc_param : "")+"}");
              if (tab.id!=="upload" && tab.id!=="assign" && !tParam.hidden) {
                const panels = tab.panels
                // console.log("tab="+curTab+","+String(tab.id))
                // console.log("tab hidden="+(curTab !== String(tab.id)))
              if (curTab === String(tab.id)) 
                return (
                  <>
                  {Object.keys(panels)?.map((key:any) => {

                    const panel = util.getKeyValue(key)(panels)
                    const pParam = JSON5.parse("{"+(panel.spc_param ? panel.spc_param : "")+"}");
                    if (panel.hidden === undefined && pParam.hidden!==null && pParam.hidden !== undefined) {
                      panel.hidden = pParam.hidden
                    }
                    //console.log("panel.hidden:"+panel.field_name+":"+panel.hidden)

                    if (panel.inps.length>0 && !panel.hidden) {
                        var pStyle = pParam.style
                        if (!pStyle) {
                          pStyle = {}
                          pStyle.height = "45px"
                        }

                        const pLabelMap = util.getLabelMap(panel.display_name)
                        if (pParam.weight === "bold") {
                          pLabelMap.label = "<b>"+pLabelMap.label+"</b>"
                        }
                        
                    return (
                      <IonList key={key}>
                        {panel.display_name ?
                        <IonItemDivider color={pParam.bgColor ? pParam.bgColor : "light"} style={pStyle ? pStyle : undefined} 
                                        onClick={(e) => {panel.expand = !panel.expand;setTabs(prevState => ([...prevState]))}}>
                          {pParam.hideIcon ? "" :
                          <><IonIcon icon={panel.expand ? chevronDown : chevronForward}/>&nbsp;</>
                          }
                          <IonLabel className="ion-text-wrap" color={pParam.color ? pParam.color : "dark"}>
                            <span dangerouslySetInnerHTML={{__html: pLabelMap.label}}></span>
                          </IonLabel>
                        </IonItemDivider>
                        : "" }

                    {panel.inps?.map((inpName:any,j:any) => {
                        //inputs = []

                        const inp = util.getKeyValue(inpName)(inps)
                        const param = JSON5.parse("{"+(inp.spc_param ? inp.spc_param : "")+"}");

                        if (!inp.hidden && ((!param.hidden && !isEditMode()) || isEditMode())) {
                          var style = param.style
                          if (!style) {
                            style = {}
                          }
                          style.minHeight = (inp.display_height ? inp.display_height : 60)+"px"
                          style.height = (inp.display_height ? inp.display_height : 60)+"px"

                          var istyle = {"--min-height":'60px'}
                          istyle["--min-height"] = (inp.display_height ? inp.display_height : 60)+"px"

                          const ro = isReadOnly(param, inp)

                          var ctrlRules = {required:inp.is_mandatory}

                          //console.log("ro:"+ro+":"+inpName)
                          const labelMap = util.getLabelMap(inp.display_name)
                          if (inp.is_mandatory && labelMap.label) {
                            labelMap.label = labelMap.label + '<font color="red"> *</font>';
                          }

                          var field;
                          if (ro) {

                              var v = ""

                              if (inp.display_type === "C") {
                                //v = moment(inp.value).format(inp.display_format)
                                console.log("date value:"+inp.value)
                                v = format(parseISO(inp.value!), inp.display_format)
                              } else
                              if (inp.display_type === "L") {
                                v = inp.valueLabel
                              } else {
                                v = inp.value
                              }

                              if (inp.display_type === "T" && (inp.field_type==="I" || inp.field_type==="F")) {
                                  const df = inp.display_format?.split("|")

                                  field = (
                                    <>
                                      <IonLabel className="ion-text-wrap" position="floating">
                                        <span dangerouslySetInnerHTML={{__html: labelMap.label}}></span>
                                      </IonLabel>
                                      <NumberInput value={inp.value} 
                                        prefix={df.length>3 ? df[3] : undefined}
                                        suffix={df.length>4 ? df[4] : undefined}
                                        thousandSeparator={df.length>1 ? df[1] : ","}
                                        fixedDecimalScale={df.length>2 && parseInt(df[2])>0}
                                        decimalSeparator={df.length>2 && parseInt(df[2])>0 ? "." : undefined}
                                        decimalScale={df.length>2 ? df[2] : undefined}
                                        allowNegative={df.length>0 && df[0]}
                                        readonly={ro}
                                        onIonChange={
                                          (r: any) => {
                                          }
                                        }
                                      />
                                    </>
                                  )
                              } else {
                                field = (
                                  <>
                                  <IonInput value=" " readonly={ro} name={inp.field_name} style={style} labelPlacement="floating">
                                    <span slot="label" className="ion-text-wrap span-down" dangerouslySetInnerHTML={{__html: labelMap.label}}></span>
                                    <span slot="label" className="span-down" style={{height:"5px"}}>&nbsp;</span>
                                    <span slot="label"><IonBadge color="medium" className="badgeFont">{v}</IonBadge></span>
                                  </IonInput>
                                  </>
                                )
                              }

                              if (panel.expand) {
                                //inputs.push (
                                return (
                                  <IonItem key={j} className="itemAccordion">
                                    {field}
                                  </IonItem>
                                )
                              }
                          } else // not Read Only
                          if (inp.display_type === "T") {
                            field = mergeTextField(panel,inp,param,style,istyle,ctrlRules,labelMap,i,ro)
                          } else 
                          if (inp.display_type === "A") {
                            field = mergeTextArea(panel,inp,param,style,ctrlRules,labelMap,i,ro)
                          } else 
                          if (inp.display_type === "L") {
                            field = mergeListBox(panel,inp,param,style,istyle,ctrlRules,labelMap,i,ro)
                          } else 
                          if (inp.display_type === "X") {
                            field = mergeCheckBox(panel,inp,param,style,istyle,ctrlRules,labelMap,i,ro)
                          } else 
                          if (inp.display_type === "R") {
                            field = mergeRadio(panel,inp,param,ctrlRules,labelMap,i,ro)
                          } else 
                          if (inp.display_type === "C") {
                            field = mergeCalendar(panel,inp,param,style,istyle,ctrlRules,labelMap,i,ro)
                          } else 
                          if (inp.display_type === "U") {
                            field = mergeUpload(panel,inp,param,style,istyle,ctrlRules,labelMap,i,ro)
                          } else 
                          if (inp.display_type === "B") {
                            field = mergeLabel(labelMap)
                          } else {
                            field = (
                                <IonLabel>
                                  Unknown Display Type : "{inp.display_name+":"+inp.display_type}"
                                </IonLabel>
                            )
                          }

                          /*
                            put field to inputs
                          */
                          if (!ro) {
                            if (panel.expand) {
                              if ("RLC".indexOf(inp.display_type) < 0) { // Normal Fields
                                //inputs.push(
                                return (
                                    <>
                                    <IonItem key={j} className="itemAccordion" id={"it_"+inp.field_name} style={istyle}>
                                      {field}
                                    </IonItem>
                                    {
                                      errors[inp.field_name] && <IonItem key={j+"_"}><IonLabel color="danger">{param.errorText ? param.errorText : "Please Enter Valid Value"}</IonLabel></IonItem>
                                    }
                                    </>
                                )
                              } else {
                                if (field) { // Radio, List Box, Calendar
                                  //inputs.push(field)
                                  return field
                                }
                              }
                            }
                          }
                        }

                        //return inputs
                        return ""
                    })}
                    
                    </IonList>
                    )
                  }
                })}
                
                </>
              )

            } else if (tab.id==="upload" && (!cfgs.SHOW_FILES_TAB || cfgs.SHOW_FILES_TAB === "1") && curTab==="upload") {
              return (
                  <IonList key={101}>
                    <IonItem key={1} color={info?.sepColor} className="itemStable" onClick={(e) => {
                        setExpandAtts(!expandAtts)
                      }}>
                      <IonIcon icon={expandAtts ? chevronDown : chevronForward}/>
                      <IonLabel>Attach Document</IonLabel>
                      <input
                        ref={fileInput}
                        hidden
                        type="file"
                        accept="*/*"
                        multiple
                        onChange={e => {
                          var files = []
                          for(var i=0; i<e.target.files.length;i++) {
                            const f = util.getValidFile(e.target.files[i])
                            console.log("upload "+i+":"+f.name)
                            files.push(f)
                          }
                          upload(files)
                        }}
                        onClick={(e) => {
                          e.stopPropagation()
                        }}
                      />
                      <IonButton
                        color="primary"
                        onClick={(e) => {
                          // @ts-ignore
                          fileInput?.current?.click();
                          // setBackgroundOption(BackgroundOptionType.Gradient);
                          //console.log('stopProp');
                          e.stopPropagation()
                        }}>
                        <IonIcon icon={cloudUpload}/>
                        <IonLabel>&nbsp;Upload</IonLabel>
                      </IonButton>
                    </IonItem>
                    <IonGrid>
                      {atts?.map((att,j) => {
                          return(
                            <IonItemSliding key={j}>

                            {att.action.indexOf("E")>=0 ? 
                            <IonItemOptions side="start">
                            <IonItemOption color="primary" onClick={(e) => {
                              editFile(att)
                            }}>Edit</IonItemOption>
                            </IonItemOptions>
                            : ""}

                            <IonItem key={j} className="itemAccordion ion-no-padding" hidden={!expandAtts} onClick={(e)=>{
                              if (att.nodeRef) {
                                //window.open("https://"+state.host+":"+state.port+Environment.API_PREFIX+"node/"+cid+"/content/"+att.name+"?c=force&noCache="+new Date()+"&a=false&alf_ticket="+state.ticket);
                                window.open(server.getViewDocUrl(att.nodeRef, att.name))
                              }
                            }}>
                            <IonRow className="ion-align-items-start">
                            <IonCol size="auto"><IonIcon style={{width:22,height:22}} icon={att.path ? cloudUpload : documentText}/></IonCol>
                            <IonCol>
                              <IonLabel>{j+1}</IonLabel>
                            </IonCol>
                            <IonCol>
                              <IonLabel>{att.name}</IonLabel>
                            </IonCol>
                            <IonCol>
                              <IonLabel>{att.desc}</IonLabel>
                            </IonCol>
                            </IonRow>
                            </IonItem>

                            {att.action.indexOf("D")>=0 ? 
                            <IonItemOptions side="end">
                            <IonItemOption color="danger" onClick={(e) => {
                              deleteFile(att)
                            }}>Remove</IonItemOption>
                            </IonItemOptions>
                            : ""}

                            </IonItemSliding>
                          )
                      })}
                    </IonGrid>
                  </IonList>
              )
            } else if (tab.id==="assign" && (!cfgs.SHOW_ASSIGNMENT_TAB || cfgs.SHOW_ASSIGNMENT_TAB === "1") && curTab==="assign") {
              return (
                <>
                <IonList key={102}>
                  <IonItem key={1} color={info?.sepColor} className="itemStable" onClick={(e) => {setExpandTaskCloser(!expandTaskCloser)}}>
                      <IonIcon icon={expandTaskCloser ? chevronDown : chevronForward}/>
                      <IonLabel>Task Closer</IonLabel>
                      <IonButton color="primary"
                        onClick={(e) => {
                          console.log("addCloser")
                          setShowPicker({ showPicker:true, list:'C', title:'Task Closer', notIn:closers, firstTime:true})
                          e.stopPropagation()
                        }}>
                        <IonIcon icon={addOutline}/>
                        <IonLabel>&nbsp;Add</IonLabel>
                      </IonButton>
                  </IonItem>
                  <IonGrid>
                      {closers?.map((ug,j) => {
                          return(
                            <IonItemSliding key={j}>

                            {expandTaskCloser ?
                            <IonItem key={j} className="itemAccordion ion-no-padding">
                            <IonRow className="ion-align-items-start">
                              <IonCol size="auto"><IonIcon style={{width:22,height:22}} icon={ug.type==="U" ? personOutline : peopleOutline}/></IonCol>
                              <IonCol>
                                <IonLabel>{j+1}</IonLabel>
                              </IonCol>
                              <IonCol>
                                <IonLabel>{ug.name}</IonLabel>
                              </IonCol>
                            </IonRow>
                            </IonItem>
                            : "" }

                            <IonItemOptions side="end">
                            <IonItemOption color="danger" onClick={(e) => {
                              document.querySelector("ion-item-sliding").closeOpened();
                              deleteCloser(ug)
                            }}>Remove</IonItemOption>
                            </IonItemOptions>

                            </IonItemSliding>
                          )
                      })}
                    </IonGrid>
                </IonList>
                <IonList key={103}>
                  <IonItem key={1} color={info?.sepColor} className="itemStable" onClick={(e) => {setExpandRelated(!expandRelated)}}>
                      <IonIcon icon={expandRelated ? chevronDown : chevronForward}/>
                      <IonLabel>Related</IonLabel>
                      <IonButton color="primary"
                        onClick={(e) => {
                          console.log("addRelated")
                          setShowPicker({ showPicker:true, list:'R', title:'Related', notIn:relates, firstTime:true})
                          e.stopPropagation()
                        }}>
                        <IonIcon icon={addOutline}/>
                        <IonLabel>&nbsp;Add</IonLabel>
                      </IonButton>
                  </IonItem>
                  <IonGrid>
                      {relates?.map((ug,j) => {
                          return(
                            <IonItemSliding key={j}>

                            {expandRelated ?
                            <IonItem key={j} className="itemAccordion ion-no-padding">
                            <IonRow className="ion-align-items-start">
                              <IonCol size="auto"><IonIcon style={{width:22,height:22}} icon={ug.type==="U" ? personOutline : peopleOutline}/></IonCol>
                              <IonCol>
                                <IonLabel>{j+1}</IonLabel>
                              </IonCol>
                              <IonCol>
                                <IonLabel>{ug.name}</IonLabel>
                              </IonCol>
                            </IonRow>
                            </IonItem>
                            : ""}

                            <IonItemOptions side="end">
                            <IonItemOption color="danger" onClick={(e) => {
                              document.querySelector("ion-item-sliding").closeOpened();
                              deleteRelated(ug)
                            }}>Remove</IonItemOption>
                            </IonItemOptions>

                            </IonItemSliding>
                          )
                      })}
                    </IonGrid>
                </IonList>
                </>
            )
            }

          }})}
          </form>

          <IonModal
            isOpen={showMsg}
            onDidDismiss={async () => {
              setShowLoading(false)
              setShowMsg(false)
              if (sending) {
                const script1 = await server.getScript("BFC", formatId)
                eval(script1)
            
//                goPrevious()
                goLastUrl()

                const script2 = await server.getScript("FC", formatId)
                eval(script2)

                setCurId("")
              } else {
                setShowBackdrop(false)
              }
            }}
            backdropDismiss={true}
            showBackdrop={true}
            className="success-modal"
            onDidPresent={()=>{
              setShowBackdrop(true)
              setTimeout(()=>{
                setShowMsg(false)
              },6000)
            }}
          >
            <IonContent color="success">
              <IonLabel color="light" className="modal-msg"><b>Success : {curId}</b></IonLabel>
            </IonContent>
          </IonModal>

          <IonLoading 
              isOpen={showLoading}
              onDidDismiss={() => setShowLoading(false)}
              message="Please wait..."
            />

          <UserGroupPicker state={{showPicker:pickerState.showPicker, list:pickerState.list, title:pickerState.title, notIn:pickerState.notIn}} 
            onDismiss={() => {setShowPicker({showPicker:false, list:'', title:'',notIn:[], firstTime:true})}}
            addUG={(list:any,ug:any) => {
              if(list==="C") {
                let found = false
                closers?.forEach((r) => {
                  if (r.id === ug.id) {
                    found = true
                  }
                })
                if (!found) {
                  setClosers(prevState => ([...prevState, ug]))
                }
              } else {
                let found = false
                relates?.forEach((r) => {
                  if (r.id === ug.id) {
                    found = true
                  }
                })
                if (!found) {
                  setRelates(prevState => ([...prevState, ug]))
                }
              }
            }}
          />

          <ListBox state={{showPicker:listBoxState.showPicker, title:listBoxState.title, inp:listBoxState.inp, id:curId, inps:inps, onChange:listBoxState.onChange}} 
            onDismiss={() => {
              setShowListBox({showPicker:false, title:'', inp:null, id:null, inps:null, onChange:null})
            }}
            onSelect={async (item:any,inp:any) => {
              console.log("onSelect:"+inp.field_name+":value:"+inp.value+",newValue:"+item.id+"("+item.name+")")
              inp.value = item.id
              inp.valueLabel = item.name

              await handleTrigger(inp, inps)

              if (inp.field_name.startsWith("H_") && inp.save_to_field === "format_id") {
                setOpened(true)
                setFormatId(item.id)
              }
            }}
          />
        </IonContent>

        
    </IonPage>

  );
}

export default Form;
